<template>
  <v-row
    no-gutters
    class="
      flex-nowrap column-gap
    "
  >
    <v-col
      v-for="(option, optionIndex) in options"
      :key="optionIndex"
    >
      <v-checkbox
        v-model="selectedOption"
        :value="option.value"
        @change="iresaStopSale(option.value)"  
        class="body-1"
        :disabled="isDisabled(option.value)"
      >
        <template v-slot:label>
          <span class="h2s color-unset font-weight-regular">{{ option.label }}</span>
        </template>
      </v-checkbox>
    </v-col>
  </v-row>
</template>

<script>
import { EventBus } from '../../mixins'

export default {
  props: {
    item: {
      type: Object,
      default: null
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedOption: this.item.sellStatus,
    };
  },
  computed: {
    isDisabled() {
      return (value) => {
        //* Enable if the option is not presented in options
        const foundedOption = this.options.find(option => option.value === this.selectedOption);
        
        if (!foundedOption) return false;

        return this.selectedOption !== value;
      }
    }
  },
  methods: {
    async iresaStopSale(option) {   
      this.$emit('toggle-loading');
      
      let notification = {
          type: 'success'
      };

      this.$emit('set-items-new-value', this.item.dateDepart, 'sellStatus', this.selectedOption, this.item.iresaCode);

      switch (this.$store.state.activeBrand) {
        case 'labalaguere':
          notification = await this.handleLabalaguereOption(option);
          
          if (notification.type === 'success') {            
            const { data } = notification;
            
            if (data && data.guidStopVent) {
              this.$emit('set-items-new-value', this.item.dateDepart, 'guidStopVent', data.guidStopVent, this.item.iresaCode);        
            }            
          }
          
          break;          
        case 'ucpa':
          // Handle UCPA
          break;          
      }

      this.$emit('toggle-loading');

      EventBus.$emit('show-notifications', [notification]);
    },
    handleLabalaguereOption(option) {
      switch(option) {
        case 'Confirmé': {
          return this.$store.dispatch('setSellState', { 
            iresaCode: this.item.iresaCode, 
            dateDepart: this.item.dateDepart, 
            status: this.selectedOption || ''
          });
        }   
        case 'Annulé': {
          return this.$store.dispatch('iresaStopSale', { 
            iresaCode: this.item.iresaCode, 
            dateDepart: this.item.dateDepart,
            dateRetourn: this.item.dateRetourn,
            guidStopVent: this.item.guidStopVent,
            status: this.selectedOption || '',
            isCancelation: !!this.selectedOption
          });
        }          
      }    
    }
  },
  watch: {
    'item.sellStatus': function(newValue, oldValue) {
      if (newValue !== oldValue) this.selectedOption = newValue;
    }
  }  
};
</script>

<style scoped>
  .column-gap {
    column-gap: 22px;
  }
  .color-unset {
    color: unset;
  }
</style>